import React from 'react';
import RichTextContent, { RichTextContentProps } from './RichTextContent';
import { RichTextDataTarget } from 'types/RichTextContent';

const getUrlForTarget = (target: RichTextDataTarget) => {
  const { id: entryId, contentType } = target.sys;
  const { slug } = target.fields;

  if (!contentType) {
    return null;
  }

  const { id: contentTypeId } = contentType.sys;

  return `/${contentTypeId}/${entryId}/${slug}`;
};

const EntryHyperlink = ({ node }: RichTextContentProps) => {
  const { data } = node;

  if (!data || !data.target) {
    return null;
  }

  const url = getUrlForTarget(data.target);

  if (!url) {
    return null;
  }

  return (
    <a href={url} target="_blank" rel="noreferrer">
      <RichTextContent node={node} />
    </a>
  );
};

export default EntryHyperlink;
